import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const GAME_UUID = "233a023c-b8ff-4cd6-b1eb-fc4986e66864";
export const socialSharingTweetA =
  "Signed up for the OverKnights Closed Alpha @OverKnightsGame. I’ve been waiting for this—time to build my robotic warrior and dominate!";
const overknightsQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-wishlist-added`,
    ruleId: `${GAME_UUID}-wishlist`,
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord Community",
    caption: "Connect with players and join the discussion",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-discord-real-event`,
    ruleId: `${GAME_UUID}-discord-real`,
    linkUrl: "https://discord.gg/2jbbyJ5CnY",
  },
];
const overknightsQuestsLvl2: Quest[] = [
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Download the game",
    caption: "Dive into the Overknights universe",
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-website-download-game-event`,
    ruleId: `${GAME_UUID}-website-download-game`,
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Complete the Early Access Form",
    caption: "Complete the Early Access form",
    linkUrl: "https://forms.gle/oUsanY1orhL6Qqof8",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-early-access-event",
    ruleId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-early-access",
  },
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X about playing Overknights",
    caption: "Extra Gems for sharing on X",
    linkUrl: `https://twitter.com/intent/tweet?text=${encodeURIComponent(socialSharingTweetA)}`,
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-x-sharing-event`,
    ruleId: `${GAME_UUID}-x-sharing`,
    startTime: new Date("2025-04-23T00:00:00Z"),
    tweetText: socialSharingTweetA,
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow Overknights on X",
    caption: "Don't miss a tweet",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-twitter-event`,
    ruleId: `${GAME_UUID}-twitter`,
    linkUrl: "https://x.com/OverKnightsGame",
  },
];
export const overknightsQuests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      title: "Learn and connect",
      description: "Level 1 Supporter",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +20 <icon> Gems",
    totalGemsGranted: 20,
    hideOnCompletion: true,
    lockedUntilPrevious: true,
    quests: overknightsQuestsLvl1,
    introModal: {
      title: "You're on your way to Level 1",
      description:
        "Thanks for following Overknights. Keep showing your support and earn better perks while doing it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z_dhd-vxEdbNO0zZ_OVKs-Blue.webp?auto=format,compress",
    },
  },
  {
    key: "level-2",
    header: {
      image: "",
      title: "Dive deeper",
      description: "Level 2 Believer",
    },
    nextQuest: {
      url: "/games/ravenquest",
      title: "Thanks for getting involved",
      label: "Want more? Check out RavenQuest",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +40 <icon> Gems",
    totalGemsGranted: 40,
    hideOnCompletion: false,
    lockedUntilPrevious: true,
    quests: overknightsQuestsLvl2,
    introModal: {
      title: "Level 2, here you go",
      description:
        "People like you are making Overknights a better and bigger game. Let's keep at it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z_dheevxEdbNO0zb_TESSERACT_MKT_-NO_BG-.webp?auto=format,compress",
    },
    exitModal: {
      title: "That's all folks",
      description:
        "Level 2 Believer achieved. Bigger and better quests are on the horizon!",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z_dheOvxEdbNO0za_Q-BIT_MKT_-NO_BG-.webp?auto=format,compress",
    },
  },
];
